import { Metric } from "@/services/user/leaderboard/leaderboardTypes";

// Kept apart from leaderboardHelpers.ts: the router imports this file, so it must stay free of icons and dayjs.

/** The ladders that can be browsed in full. The weekly purchases ladder lives only in the rewards card. */
export const LadderMetrics = [Metric.TotalPoints, Metric.CollectionItems, Metric.MarketplaceItems, Metric.GivenLikes, Metric.ReceivedLikes] as const;

export type LadderMetric = (typeof LadderMetrics)[number];

/** URL segment of each browsable ladder. */
export const LadderMetricSlug: Record<LadderMetric, string> = {
  [Metric.TotalPoints]: "points",
  [Metric.CollectionItems]: "collection-items",
  [Metric.MarketplaceItems]: "marketplace-items",
  [Metric.GivenLikes]: "likes-given",
  [Metric.ReceivedLikes]: "likes-received",
};

/** Route param pattern matching exactly the browsable ladders. */
export const LadderMetricSlugPattern = LadderMetrics.map((metric) => LadderMetricSlug[metric]).join("|");

/** Reads a ladder back from a URL segment; anything unrecognized is the total points ladder. */
export const parseLadderMetric = (value: unknown): LadderMetric => LadderMetrics.find((metric) => LadderMetricSlug[metric] === value) ?? Metric.TotalPoints;
